import api from "src/api/index"
import { appLocalStorage } from "src/libs"
import { useAppData } from "src/store/app-data"

export async function refreshPermissions() {
  try {
    const response = await api.get("me")
    const permissions = response?.data?.permissions ?? []
    const resourceAccess = response?.data?.resourceAccess ?? {}

    const existingUser = appLocalStorage.getData("user") ?? {}
    appLocalStorage.setData("user", { ...existingUser, permissions, resourceAccess })

    useAppData.getState().setPermissions(permissions)
    useAppData.getState().setResourceAccess(resourceAccess)
  } catch (error) {
    console.error("Failed to refresh permissions", error)
  }
}
